var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.newVersion
    ? _c(
        "md-field",
        { staticClass: "phone-field", class: { "md-invalid": !!_vm.errors } },
        [
          _vm.showLabel
            ? _c("label", [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-menu",
            {
              staticClass: "shrink-0",
              attrs: { "md-direction": "bottom-start" }
            },
            [
              _c(
                "md-button",
                { attrs: { "md-menu-trigger": "" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.selectedCountry &&
                          _vm.countriesMap[_vm.selectedCountry]
                          ? _vm.countriesMap[_vm.selectedCountry].callingCode
                          : ""
                      ) +
                      "\n            "
                  ),
                  _c("custom-icon", { attrs: { name: "arrow_drop_down" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-menu-content",
                _vm._l(_vm.countries, function(country) {
                  return _c(
                    "md-menu-item",
                    {
                      key: country.idPays,
                      attrs: { dusk: "phone_country_" + country.isoCode },
                      on: {
                        click: function($event) {
                          _vm.selectedCountry = country.idPays
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            country.isoCode + " (" + country.callingCode + ")"
                          ) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("md-input", {
            attrs: {
              placeholder: _vm.showLabel ? null : _vm.label,
              name: _vm.name,
              disabled: _vm.disabled,
              required: _vm.required,
              type: "tel",
              autocomplete: "tel"
            },
            on: {
              blur: function($event) {
                _vm.wasFocused = true
              }
            },
            model: {
              value: _vm.useValue,
              callback: function($$v) {
                _vm.useValue = $$v
              },
              expression: "useValue"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.errors ? _vm.errors[0] : ""))
          ])
        ],
        1
      )
    : _c("div", { staticClass: "PhoneFieldComponent" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "md-menu",
              {
                staticClass:
                  "shrink-0 z-10 inline-flex items-center px-0 text-sm font-medium text-center bg-white border border-gray-200 text-gray-900 border-e-0 rounded-s-md hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-300",
                attrs: { "md-direction": "bottom-start" }
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass:
                      "!py-0 !min-w-8 !px-1 nv-button text-sm font-normal h-auto",
                    attrs: { "md-menu-trigger": "" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.selectedCountry &&
                            _vm.countriesMap[_vm.selectedCountry]
                            ? _vm.countriesMap[_vm.selectedCountry].callingCode
                            : ""
                        ) +
                        "\n                "
                    ),
                    _c("custom-icon", { attrs: { name: "arrow_drop_down" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "md-menu-content",
                  { staticStyle: { "z-index": "120" } },
                  _vm._l(_vm.countries, function(country) {
                    return _c(
                      "md-menu-item",
                      {
                        key: country.idPays,
                        attrs: { dusk: "phone_country_" + country.isoCode },
                        on: {
                          click: function($event) {
                            _vm.selectedCountry = country.idPays
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              country.isoCode + " (" + country.callingCode + ")"
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "relative w-full" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.useValue,
                    expression: "useValue"
                  }
                ],
                staticClass:
                  "block bg-white border border-gray-200 text-gray-900 text-sm rounded-e-md focus:ring-blue-900 block w-full p-1.5 w-full z-20 placeholder:italic",
                class: {
                  "border-red-500 focus:border-red-500 focus:ring-red-500": !!_vm.errors
                },
                attrs: {
                  placeholder: _vm.showLabel ? null : _vm.label,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  required: _vm.required,
                  type: "tel",
                  autocomplete: "tel"
                },
                domProps: { value: _vm.useValue },
                on: {
                  blur: function($event) {
                    _vm.wasFocused = true
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.useValue = $event.target.value
                  }
                }
              })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.errors
          ? _c("p", { staticClass: "mt-2 text-xs text-red-500" }, [
              _vm._v(_vm._s(_vm.errors ? _vm.errors[0] : ""))
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f20af82c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f20af82c","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/PhoneFieldComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f20af82c","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/PhoneFieldComponent.vue
// module chunks = 1 2 3